const widgetConfig = {
  data() {
    return {
      pageLoading: false,
      btnLoading: false
    }
  },
  methods: {
    getId() {
      return parseInt(this.$route.params.id)
    },
    async getWidgetConfig(id) {
      const result = await this.apiGet(`mobile/components/${id}/get`)
      return this.promiseHandler({}, result)
    },
    handleResult(res) {
      if (res.code == 200) {
        _g.toastMsg(this, 'success', '保存成功！')
        setTimeout(() => {
          this.goBack()
        }, 1000)
      } else {
        _g.dealError(this, res)
        this.btnLoading = false
      }
    },
    goBack() {
      _g.goBack()
    }
  }
}
export default widgetConfig



// WEBPACK FOOTER //
// ./src/components/Mobile/page/abstract/widgetConfig.js